import dlv from 'dlv';
import * as React from 'react';
import { themr } from 'react-css-themr';
import EntityContent from '../EntityContent';
import Toc from '../Toc';
function DumpEntityContentWithToc({ entity, offset, duration, shift, ease, renderContent = (_entity) => React.createElement(EntityContent, { entity: entity }), theme = {}, }) {
    return (React.createElement("div", { className: theme.root },
        React.createElement("div", { className: theme.main },
            React.createElement(Toc, { offset: offset, duration: duration, shift: shift, ease: ease, source: dlv(entity, 'content.md', ''), theme: theme.toc }),
            renderContent(entity))));
}
export const defaultEntityContentWithTocTheme = {
    root: 'flex-l',
    main: 'w-100 w-70-l',
};
const EntityContentWithToc = themr('EntityContentWithToc', {}, {
    composeTheme: 'softly',
})(DumpEntityContentWithToc);
export default EntityContentWithToc;
//# sourceMappingURL=index.js.map